import type { ActionFunctionArgs } from '~/types/route-args';
import type { ErrorResponse } from '@modules/root/graphql/responses';
import {
    ServerErrorResponse,
    SuccessResponse,
} from '@modules/root/graphql/responses';
import type { ApolloError } from '@apollo/client';
import type {
    RegisterForNewsLetterMutation,
    RegisterForNewsLetterMutationVariables,
} from 'generated/graphql';
import { RegisterForNewsLetterDocument } from 'generated/documents/RegisterForNewsLetterDocument';
import { legacy_handleGraphqlError } from '@modules/root/graphql/utils.server';
import { subscriptionSchema } from '@modules/navigation/component/subscription/Subscription';
import { getSession } from '~/modules/root/util/session.server';

export const USER_SUBSCRIPTION_API_ROUTE = '/remix-api/user/subscription';

export type SubscriptionAction = ErrorResponse | SuccessResponse<string>;

export const action = async ({ request, context }: ActionFunctionArgs) => {
    const { client } = context;
    const data = await request.formData();

    const parse = subscriptionSchema.safeParse({ email: data.get('email') });

    if (!parse.success) {
        return new ServerErrorResponse(parse.error);
    }

    try {
        await client.mutate<
            RegisterForNewsLetterMutation,
            RegisterForNewsLetterMutationVariables
        >({
            mutation: RegisterForNewsLetterDocument,
            variables: {
                Email: parse.data.email,
            },
        });
        const session = await getSession(request);
        session.flashToastMessage({
            message: 'You are now subscribed to our newsletter!',
            type: 'success',
        });
        const cookie = await session.commit();

        return new SuccessResponse(
            'You are now subscribed to our newsletter!',
            { ...(cookie && { headers: await session.getHeaders() }) },
        );
    } catch (e) {
        return legacy_handleGraphqlError(e as ApolloError);
    }
};
